import * as React from 'react'
import { POSNavbar } from './POSNavbar'
import { UberEatsIncomingOrderBar } from './UberEats/UberEatsIncomingOrderBar'

export const DEFAULT_HEADER_HEIGHT = 56

/**
 * Navbar and Uber Eats alert bar pinned together at the top. The navbar wraps its links on narrow
 * windows and the bar comes and goes, so the spacer follows the measured height instead of a
 * hard-coded one.
 */
const POSHeader = () => {
  const headerRef = React.useRef<HTMLDivElement>(null)
  const [height, setHeight] = React.useState(DEFAULT_HEADER_HEIGHT)

  React.useLayoutEffect(() => {
    const header = headerRef.current
    if (!header) return undefined

    const measure = () => setHeight(Math.ceil(header.getBoundingClientRect().height))
    measure()
    if (typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(measure)
    observer.observe(header)
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <div
        ref={headerRef}
        data-testid='pos-header'
        style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1 }}
      >
        <POSNavbar />
        <UberEatsIncomingOrderBar />
      </div>
      <div data-testid='pos-header-spacer' style={{ height, flexShrink: 0 }} />
    </>
  )
}

export const POSShell: React.FC = ({ children }) => (
  <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
    <POSHeader />
    <div
      data-testid='pos-content'
      style={{ width: 'calc(100vw)', flex: 1, minHeight: 0, height: '100%' }}
    >
      {children}
    </div>
  </div>
)
